
import React, { useState, useEffect } from "react";
import clapperboardIcon from '../../../assets/images/edit-icon.png';
import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
  Chip,
  OutlinedInput,
  Grid,Tooltip, IconButton
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { CheckCircle, Plus, Minus, ChevronDown, Upload } from "lucide-react";
import MovieServices from "../../services/externalServices/TicketServices/moviesServices";
import TheatreServices from "../../services/externalServices/TicketServices/theatreServices";
import InfoIcon from '@mui/icons-material/Info';

const languages = ["English", "Tamil", , "Telugu", "Kannada", "Hindi", "Malayalam"];
const genres = ["Action", "Comedy", "Drama", "Romance", "Adventure", "Horror"];

const EditMovie = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const movie = location.state?.movie;


// Add state for feedback message
const [infoMessage, setInfoMessage] = useState('');

  // Get admin info from localStorage
  // const { role = "", accessList = [] } = JSON.parse(localStorage.getItem("admin")) || {};
  const { role = "", accessList: storedAccessList = [] } = JSON.parse(localStorage.getItem("admin")) || {};
  const [theatres, setTheatres] = useState([]);

  const [loading, setLoading] = useState(true);


  // If the role is ticket-admin, get the access list from localStorage directly
  const accessList = role === "ticket-admin" ? storedAccessList : movie?.availableIn;

  console.log('movies in the edit movie===', movie?.availableIn[0]?.name)





  // useEffect(() => {
  //   const fetchTheatres = async () => {
  //     try {
  //       const response = await TheatreServices.getTheatres();
  //       const theatreList = response || []; // Safeguard the response

  //       setTheatres(theatreList);

  //       // Ensure movie and availableIn are valid before filtering
  //       const matchedIds = movie?.availableIn?.filter(id =>
  //         theatreList.some(theatre => theatre._id === id)
  //       ) || []; // Fallback to an empty array if no valid IDs are found

  //       setFormData(prev => ({
  //         ...prev,
  //         accessList: matchedIds // Update accessList
  //       }));

  //     } catch (error) {
  //       console.error("Error fetching theatres:", error);
  //     }
  //   };

  //   if (role !== "ticket-admin") {
  //     fetchTheatres();
  //   } else {
  //     setLoading(false);
  //   }
  // }, [movie, role]); // Ensure this effect runs when movie or role changes


  useEffect(() => {
    const fetchTheatres = async () => {
      try {
        const response = await TheatreServices.getTheatres();
        const theatreList = response || [];
        setTheatres(theatreList);

        // if (role === "ticket-admin") {
        //   // Convert stored theatre names to IDs
        //   const matchedIds = storedAccessList
        //     .map(name => theatreList.find(t => t.name === name)?._id)
        //     .filter(Boolean);

        //   setFormData(prev => ({
        //     ...prev,
        //     accessList: matchedIds
        //   }));
        // } else {
        //   // For other roles, use movie's availableIn directly
        //   setFormData(prev => ({
        //     ...prev,
        //     accessList: movie?.availableIn?.filter(id =>
        //       theatreList.some(t => t._id === id)
        //     ) || []
        //   }));
        // }










        // if (role === "ticket-admin") {
        //   const matchedIds = storedAccessList
        //     .map(name => theatreList.find(t => t.name === name)?._id)
        //     .filter(Boolean);
        //   setFormData(prev => ({
        //     ...prev,
        //     accessList: matchedIds
        //   }));
        // } else {
        //   const matchedIds = (movie?.availableIn || [])
        //     .map(item => {
        //       const name = typeof item === "string" ? item : item.name; // handle both formats
        //       return theatreList.find(t => t.name === name)?._id;
        //     })
        //     .filter(Boolean);

        //   setFormData(prev => ({
        //     ...prev,
        //     accessList: matchedIds
        //   }));
        // }


        const allTheatreIds = theatreList.map(t => t._id);

        setFormData(prev => ({
          ...prev,
          accessList: allTheatreIds,
        }));





        setLoading(false);
      } catch (error) {
        console.error("Error fetching theatres:", error);
        setLoading(false);
      }
    };

    fetchTheatres();
  }, [movie, role]);






  const [formData, setFormData] = useState({
    name: movie?.name || "",
    about: movie?.about || "",
    duration: movie?.duration || "",
    genre: movie?.genre || [],
    imdbRating: movie?.imdbRating || "",
    cast: movie?.cast || [],
    crew: movie?.crew || [],
    imageUrl: movie?.imageUrl || "",
    trailerUrl: movie?.trailerUrl || "",
    releaseDate: movie?.releaseDate?.split("T")[0] || "",
    censorRating: movie?.censorRating || "",
    movieLanguages: movie?.movieLanguages || [],
    isReadyForBooking: movie?.isReadyForBooking || false,
    // accessList: role === "ticket-admin" ? accessList : movie?.availableIn,
    accessList: [],
    // accessList:
    //   (role === "ticket-admin"
    //     ? storedAccessList
    //       .map(name => theatres.find(t => t.name === name)?._id || name)
    //       .filter(Boolean)
    //     : movie?.availableIn.map(name => theatres.find(t => t.name === name)?._id || name)
    //       .filter(Boolean)),
  });

  useEffect(() => {
    console.log('formdata------', formData)
  }, [])

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleMultiChange = (e, field) => {
    const {
      target: { value },
    } = e;
    setFormData((prev) => ({
      ...prev,
      [field]: typeof value === "string" ? value.split(",") : value,
    }));
  };

  const handleCastCrewChange = (type, index, field, value) => {
    const updatedList = [...formData[type]];
    updatedList[index][field] = value;
    setFormData({ ...formData, [type]: updatedList });
  };




  // For cast and crew

  const addCastMember = () => {
    setFormData({
      ...formData,
      cast: [...formData.cast, { name: "", inAs: "", imageURL: "", priority: 0 }]
    });
  };

  const addCrewMember = () => {
    setFormData({
      ...formData,
      crew: [...formData.crew, { name: "", role: "", imageURL: "", priority: 0 }]
    });
  };

  const removeCastMember = (index) => {
    const newCast = [...formData.cast];
    newCast.splice(index, 1);
    setFormData({ ...formData, cast: newCast });
  };

  const removeCrewMember = (index) => {
    const newCrew = [...formData.crew];
    newCrew.splice(index, 1);
    setFormData({ ...formData, crew: newCrew });
  };



  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // ✅ Ensure accessList is correct for ticket-admin
      let updatedFormData = { ...formData };

      console.log('beofre the ticlet-admin', updatedFormData?.accessList);
      console.log('beofre the ticlet-admin', updatedFormData?.availableIn);

      // if (role === "ticket-admin") {
      //   const ids = storedAccessList
      //     .map(name => theatres.find(t => t.name === name)?._id)
      //     .filter(Boolean);
      //   updatedFormData.accessList = ids;
      // }

      console.log("Form Data Submitted: ", updatedFormData?.accessList);
      console.log("Form Data Submitted: ", updatedFormData?.availableIn);

      const response = await MovieServices.updateMovie(movie._id, formData);

      if (response && response._id) {
        console.log("Movie added successfully:", response);
        console.log('reponse in the Editmovie', response);
        alert("Movie updated successfully");
        navigate("/movies");
        // setMovieData(initialMovieData);
        // setSubmitted(true);
        // navigate(-1);
      } else if (response.message) {
        alert("❌ " + response.message);
      }


    } catch (err) {
      console.error(err);
      alert("Failed to update movie");
    }
  };


  useEffect(() => {
    if (role === "ticket-admin" && storedAccessList.length > 0) {
      const ids = storedAccessList
        .map(name => theatres.find(t => t.name === name)?._id)
        .filter(Boolean);

      // Only update if the accessList is different from the existing one
      if (JSON.stringify(ids) !== JSON.stringify(formData.accessList)) {
        console.log("Initializing accessList: ", ids);
        setFormData(prev => ({
          ...prev,
          accessList: ids,
        }));
      }
    }
  }, [role, storedAccessList, theatres, formData.accessList]);



  // const handleDelete = (id) => {
  //   setFormData((prev) => ({
  //     ...prev,
  //     accessList: prev.accessList.filter((item) => item !== id), // Remove selected item
  //   }));
  // };

  const handleDelete = (id) => {
    // Only allow delete if not ticket-admin
    if (role !== "ticket-admin") {
      setFormData((prev) => ({
        ...prev,
        accessList: prev.accessList.filter((item) => item !== id),
      }));
    }
  };


  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   try {
  //     let dataToSend = { ...formData };

  //     if (role === "ticket-admin") {
  //       // For ticket-admin, we need to send theatre names instead of IDs
  //       const theatreNames = formData.accessList
  //         .map(id => theatres.find(t => t._id === id)?.name)
  //         .filter(Boolean);

  //       dataToSend = {
  //         ...formData,
  //         accessList: theatreNames
  //       };
  //     }

  //     await MovieServices.updateMovie(movie._id, dataToSend);
  //     alert("Movie updated successfully");
  //     navigate("/movies");
  //   } catch (err) {
  //     console.error(err);
  //     alert("Failed to update movie");
  //   }
  // };

  return (
    <div className="max-w-4xl mx-auto my-8 mb-8 p-6 bg-white rounded-xl shadow-lg">
      {/* Header Section */}
      <div className="flex items-center space-x-4 mb-10">
        <div className="pl-2 rounded-lg mb-3">
          <img
            src={clapperboardIcon}
            alt="clapperboard"
            className="w-14 h-14 text-black shadow-sm  rounded-lg"
          />
        </div>
        <div>
          <h1 className="text-3xl font-bold text-gray-800">Edit Movie</h1>
          {/* <p className="text-gray-500 mt-1">Fill in the changes below to edit a movie</p>

          <Tooltip
            title={`Movie ID: ${movie?._id || 'N/A'} (Click to copy)`}
            placement="bottom"
          >
            <IconButton
              size="small"
              onClick={() => {
                navigator.clipboard.writeText(movie?._id || '').then(() => {
                  setInfoMessage('✅ Movie ID copied!');
                  setTimeout(() => setInfoMessage(''), 2000);
                });
              }}
              sx={{
                width: 32,
                height: 32,
                color: '#666',
                border: '1px solid #ddd',
                '&:hover': {
                  color: '#1976d2',
                  borderColor: '#1976d2',
                  backgroundColor: '#f5f5f5'
                }
              }}
            >
              <InfoIcon sx={{ fontSize: '1.1rem' }} />
            </IconButton>
          </Tooltip> */}

           {/* Container for subtitle and info button */}
  <div className="flex items-center gap-2 mt-1">
    <p className="text-gray-500">Fill in the changes below to edit a movie</p>
    
    <Tooltip
      title={`Movie ID: ${movie?._id || 'N/A'} (Click to copy)`}
      placement="bottom"
    >
      <IconButton
        size="small"
        onClick={() => {
          navigator.clipboard.writeText(movie?._id || '').then(() => {
            setInfoMessage('✅ Movie ID copied!');
            setTimeout(() => setInfoMessage(''), 2000);
          });
        }}
        sx={{
          width: 24,
          height: 24,
          color: '#666',
          border: '1px solid #ddd',
          '&:hover': {
            color: '#1976d2',
            borderColor: '#1976d2',
            backgroundColor: '#f5f5f5'
          }
        }}
      >
        <InfoIcon sx={{ fontSize: '0.9rem' }} />
      </IconButton>
    </Tooltip>
  </div>

        </div>
      </div>

      <form onSubmit={handleSubmit} className="space-y-6">
        <div className="bg-gray-50 p-4 rounded-lg space-y-4">
          <h2 className="text-xl font-semibold text-gray-800 mb-6 border-l-4 border-black pl-3">
            Basic Information
          </h2>
          {/* Movie Name */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Movie Name *</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              required
            />
          </div>

          {/* About */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">About</label>
            <textarea
              name="about"
              value={formData.about}
              onChange={handleChange}
              rows="3"
              className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            />
          </div>

          {/* Duration and Release Date */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Duration</label>
              <input
                type="text"
                name="duration"
                value={formData.duration}
                onChange={handleChange}
                className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Release Date</label>
              <input
                type="date"
                name="releaseDate"
                value={formData.releaseDate}
                onChange={handleChange}
                className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              />
            </div>
          </div>

          {/* Languages */}
          <div className="border-t py-4">
            <label className="block text-sm font-medium text-gray-700 mb-2">Languages</label>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-2">
              {languages.map((lang) => (
                <label key={lang} className="inline-flex items-center space-x-2 p-2 border rounded-lg hover:bg-gray-50">
                  <input
                    type="checkbox"
                    checked={formData.movieLanguages.includes(lang)}
                    onChange={(e) => {
                      const newLangs = e.target.checked
                        ? [...formData.movieLanguages, lang]
                        : formData.movieLanguages.filter((l) => l !== lang);
                      setFormData({ ...formData, movieLanguages: newLangs });
                    }}
                    className="rounded text-blue-600 focus:ring-blue-500"
                  />
                  <span className="text-sm text-gray-700">{lang}</span>
                </label>
              ))}
            </div>
          </div>

          {/* Genres */}
          <div className="border-t py-4">
            <label className="block text-sm font-medium text-gray-700 mb-2">Genres</label>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-2">
              {genres.map((gen) => (
                <label key={gen} className="inline-flex items-center space-x-2 p-2 border rounded-lg hover:bg-gray-50">
                  <input
                    type="checkbox"
                    checked={formData.genre.includes(gen)}
                    onChange={(e) => {
                      const newGenres = e.target.checked
                        ? [...formData.genre, gen]
                        : formData.genre.filter((g) => g !== gen);
                      setFormData({ ...formData, genre: newGenres });
                    }}
                    className="rounded text-blue-600 focus:ring-blue-500"
                  />
                  <span className="text-sm text-gray-700">{gen}</span>
                </label>
              ))}
            </div>
          </div>

          {/* IMDb Rating and Censor Rating */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">IMDb Rating</label>
              <input
                type="number"
                name="imdbRating"
                value={formData.imdbRating}
                onChange={handleChange}
                className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Censor Rating</label>
              <input
                type="text"
                name="censorRating"
                value={formData.censorRating}
                onChange={handleChange}
                className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              />
            </div>
          </div>

          {/* <div className="w-full mb-4">
            <label htmlFor="access-list" className="block text-sm font-medium text-gray-700 mb-1">
              Access List
            </label>
            <select
              id="access-list"
              multiple
              name="accessList"
              value={Array.isArray(formData.accessList) ? formData.accessList : []}
              onChange={(e) => {
                const selectedOptions = Array.from(e.target.selectedOptions, option => option.value);
                setFormData(prev => ({
                  ...prev,
                  accessList: selectedOptions,
                }));
              }}
              className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
            >
              {role === "ticket-admin" ? (
                storedAccessList
                  .map(theatreName => theatres.find(t => t.name === theatreName))
                  .filter(Boolean)
                  .map(theatre => (
                    <option
                      key={theatre._id}
                      value={theatre._id}
                      disabled={formData.accessList.includes(theatre._id)}
                    
                      className={`p-2 hover:bg-gray-100 ${formData.accessList.includes(theatre._id) ? 'bg-blue-100 font-semibold' : ''
                    }`}
                      >
                      {theatre.name}
                    </option>
                  ))
              ) : (
               

                theatres.map(theatre => (
                  <option
                    key={theatre._id}
                    value={theatre._id}
                    className={`p-2 hover:bg-gray-100 ${formData.accessList.includes(theatre._id) ? 'bg-blue-100 font-semibold' : ''
                      }`}
                  >
                    {theatre.name}
                  </option>
                ))
              )}
            </select>
           
            <div className="mt-2 text-sm text-gray-600">
              {Array.isArray(formData.accessList) && formData.accessList
                .map(id => theatres.find(t => t._id === id)?.name || id)
                .join(', ')}
            </div>
          </div> */}


        </div>


        {/* Media URLs */}
        <div className="bg-gray-50 p-4 rounded-lg space-y-4">
          <h2 className="text-xl font-semibold text-gray-800 mb-6 border-l-4 border-black pl-3">
            Media Information
          </h2>
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Image URL</label>
              <input
                type="text"
                name="imageUrl"
                value={formData.imageUrl}
                onChange={handleChange}
                className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Trailer URL</label>
              <input
                type="text"
                name="trailerUrl"
                value={formData.trailerUrl}
                onChange={handleChange}
                className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              />
            </div>
          </div>
        </div>

        {/* Cast Section */}
        {/* <div className="bg-gray-50 p-4 rounded-lg space-y-4">
          <div className="">
            <h3 className="text-xl font-semibold text-gray-800 mb-6 border-l-4 border-black pl-3">Cast Members</h3>
            {formData.cast.map((member, index) => (
              <div key={index} className="grid grid-cols-1 md:grid-cols-3 gap-4 p-4 bg-gray-50 rounded-lg">
                <input
                  type="text"
                  placeholder="Name"
                  value={member.name}
                  onChange={(e) => handleCastCrewChange("cast", index, "name", e.target.value)}
                  className="px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
                <input
                  type="text"
                  placeholder="Role"
                  value={member.inAs}
                  onChange={(e) => handleCastCrewChange("cast", index, "inAs", e.target.value)}
                  className="px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
                <input
                  type="url"
                  placeholder="Image URL"
                  value={member.imageURL}
                  onChange={(e) => handleCastCrewChange("cast", index, "imageURL", e.target.value)}
                  className="px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
              </div>
            ))}
          </div>
        </div> */}

        {/* Crew Section */}
        {/* <div className="bg-gray-50 p-4 rounded-lg space-y-4">
          <div className="">
            <h3 className="text-xl font-semibold text-gray-800 mb-6 border-l-4 border-black pl-3">Crew Members</h3>
            {formData.crew.map((member, index) => (
              <div key={index} className="grid grid-cols-1 md:grid-cols-3 gap-4 p-4 bg-gray-50 rounded-lg">
                <input
                  type="text"
                  placeholder="Name"
                  value={member.name}
                  onChange={(e) => handleCastCrewChange("crew", index, "name", e.target.value)}
                  className="px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
                <input
                  type="text"
                  placeholder="Role"
                  value={member.role}
                  onChange={(e) => handleCastCrewChange("crew", index, "role", e.target.value)}
                  className="px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
                <input
                  type="url"
                  placeholder="Image URL"
                  value={member.imageURL}
                  onChange={(e) => handleCastCrewChange("crew", index, "imageURL", e.target.value)}
                  className="px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
              </div>
            ))}
          </div>
        </div> */}




        <div className="bg-gray-50 p-4 rounded-lg space-y-4">
          <div className="flex justify-between items-center">
            <h3 className="text-xl font-semibold text-gray-800 border-l-4 border-black pl-3">
              Cast Members
            </h3>
            <button
              type="button"
              onClick={addCastMember}
              className="mb-4 flex items-center px-4 py-2 bg-black hover:bg-gray-800 text-white rounded-md"
            >
              <Plus className="w-4 h-4 mr-1" />
              Add Cast

            </button>
          </div>

          {formData.cast.map((member, index) => (
            <div key={index} className="grid grid-cols-1 md:grid-cols-5 gap-3 p-4 bg-white rounded-lg border relative">
              <input
                type="text"
                placeholder="Name"
                value={member.name}
                onChange={(e) => handleCastCrewChange("cast", index, "name", e.target.value)}
                className="px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              />
              <input
                type="text"
                placeholder="Role"
                value={member.inAs}
                onChange={(e) => handleCastCrewChange("cast", index, "inAs", e.target.value)}
                className="px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              />
              <input
                type="text"
                placeholder="Image URL"
                value={member.imageURL}
                onChange={(e) => handleCastCrewChange("cast", index, "imageURL", e.target.value)}
                className="px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              />

              <input


                type="number"
                placeholder="priority"
                value={member.priority}
                onChange={(e) => handleCastCrewChange("cast", index, "priority", e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md"
                required
              />

              <button
                type="button"
                onClick={() => removeCastMember(index)}
                className="p-2 text-red-600 hover:text-red-800"
              >
                <Minus className="w-5 h-5" />
                {/* Remove */}
              </button>
            </div>
          ))}
        </div>

        {/* Crew Section */}
        <div className="bg-gray-50 p-4 rounded-lg space-y-4">
          <div className="flex justify-between items-center">
            <h3 className="text-xl font-semibold text-gray-800 border-l-4 border-black pl-3">
              Crew Members
            </h3>
            <button
              type="button"
              onClick={addCrewMember}
              className="mb-4 flex items-center px-4 py-2 bg-black hover:bg-gray-800 text-white rounded-md"
            >
              <Plus className="w-4 h-4 mr-1" />
              Add Crew
            </button>
          </div>

          {formData.crew.map((member, index) => (
            <div key={index} className="grid grid-cols-1 md:grid-cols-5 gap-3 p-4 bg-white rounded-lg border relative">
              <input
                type="text"
                placeholder="Name"
                value={member.name}
                onChange={(e) => handleCastCrewChange("crew", index, "name", e.target.value)}
                className="px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              />
              <input
                type="text"
                placeholder="Role"
                value={member.role}
                onChange={(e) => handleCastCrewChange("crew", index, "role", e.target.value)}
                className="px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              />
              <input
                type="text"
                placeholder="Image URL"
                value={member.imageURL}
                onChange={(e) => handleCastCrewChange("crew", index, "imageURL", e.target.value)}
                className="px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              />

              <input


                type="number"
                placeholder="priority"
                value={member.priority}
                onChange={(e) => handleCastCrewChange("crew", index, "priority", e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md"
                required
              />
              <button
                type="button"
                onClick={() => removeCrewMember(index)}
                className="p-2 text-red-600 hover:text-red-800"
              >
                <Minus className="w-5 h-5" />
                {/* Remove */}
              </button>
            </div>
          ))}
        </div>










        {/* Ready for Booking */}
        {/* <label className="inline-flex items-center space-x-2">
          <input
            type="checkbox"
            checked={formData.isReadyForBooking}
            onChange={(e) => setFormData({ ...formData, isReadyForBooking: e.target.checked })}
            className="rounded text-green-600 focus:ring-green-500"
          />
          <span className="text-lg text-gray-700">Ready For Booking</span>
        </label> */}

        {/* Submit Button */}
        <div className="flex justify-end">
          <button
            type="submit"
            className="px-6 py-2 bg-black text-white rounded-lg hover:bg-gray-900 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
          >
            Save Changes
          </button>
        </div>
      </form>
    </div>
  );
};

export default EditMovie;

